export default 'icon--download';